export * from './carousel-slide.interface';
